import React from 'react';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Select from 'react-select';

import CustomSwitch from '../components/common/custom-switch/custom-switch.jsx';
import Text from '../components/common/custom-text/custom-text.jsx';
import { subscriptionTiers } from '../constants/subscription-tiers.js';

import styles from './plan-selector.module.scss';

function PlanSelector({ formData = {}, dispatch }) {
  const { plan, billingInterval } = formData;

  const planOptions = React.useMemo(
    () =>
      Object.values(subscriptionTiers).map(tier => ({
        value: tier,
        label: tier.title,
      })),
    []
  );

  const handlePlanChange = event => {
    const selectedPlan = event.value;
    dispatch({ type: 'UPDATE_PLAN', payload: selectedPlan });
  };

  const handleBillingIntervalChange = event => {
    const selectedInterval = event.target.checked ? 'annual' : 'monthly';
    dispatch({ type: 'UPDATE_BILLING_INTERVAL', payload: selectedInterval });
  };

  const selectStyles = {
    control: (baseStyles, state) => ({
      ...baseStyles,
      border: '1px solid #C5CCF7',
      height: '44px',
      borderRadius: '5px',
      filter: 'drop-shadow(1px 1px 1px #D1D5DB);'
    }),
    input: (baseStyles, state) => ({
      ...baseStyles,
      padding: '0px',
      fontSize: '16px',
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: '16px',
    }),
    valueContainer: (baseStyles, state) => ({
      ...baseStyles,
      padding: '0px 5px',
      height: '100%',
    }),
    indicatorSeparator: (baseStyles, state) => ({
      ...baseStyles,
      display: 'none',
    }),
    option: (baseStyles, state) => ({
      ...baseStyles,
      fontSize: '16px',
    }),
    menuList: (baseStyles, state) => ({
      ...baseStyles,
      maxHeight: '200px',
    }),
    dropdownIndicator: (baseStyles, state) => ({
      ...baseStyles,
      color: '#5E69D2',
    }),
  };

  return (
    <div className={styles.planSelector}>
      <div className={styles.inputGroup}>
        <div className="custom-text-input-field" data-testid="plan-selector">
          <Select
            value={planOptions.find(option => option.value === plan)}
            onChange={handlePlanChange}
            options={planOptions}
            menuPlacement="top"
            styles={selectStyles}
          />
        </div>
        <CustomSwitch
          id="planSwitch"
          checked={billingInterval === 'annual'}
          onChange={handleBillingIntervalChange}
          label="Annual Plan (2 months free!)"
          labelPosition="left"
          data-testid="plan-switch"
        />
      </div>
      <hr className={styles.separator} />
      <ul className={styles.planFeatures}>
        {plan.features.map((feature, i) => (
          <li key={i} className={styles.planFeature}>
            <FontAwesomeIcon icon={faCheck} color="#324975" />
            <Text as="span" variant="l3" color="#324975">
              {feature}
            </Text>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default PlanSelector;
